import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/reducers';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { MenteeRelation } from 'src/app/shared/types/mentee-relations.types';
import { Observable } from 'rxjs';
import { SETTINGS } from 'src/app/app-routing.module';
import { PUBLICLOGIN } from 'src/app/authentication-lead/authentication-lead.module';
import { roleMapping, User } from 'src/app/shared/types/user.types';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'fp-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    standalone: false
})
export class MobileMenuComponent implements OnChanges {
  mrs$: Observable<MenteeRelation[]> = this.store.select(state => state.menteeRelations);
  mobile_menu: MenuItem[];
  @Input() items: MenuItem[];
  @Input() user: User;
  @Output() hideSidebar = new EventEmitter<string>();

  constructor(
    private authService: AuthenticationService,
    private navigationService: NavigationService,
    private router: Router,
    public store: Store<AppState>,
    private translate: TranslateService
  ) {
    this.router.events.subscribe(events => {
      if (events instanceof NavigationEnd) {
        this.hideSidebar.emit();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items']) {
      if (this.items) {
        this.mobile_menu = [
          ...this.items,
          {
            label: this.translate.instant('MENU.SETTINGS'),
            routerLink: SETTINGS,
          },
          {
            separator: true,
          },
          {
            label: this.translate.instant('MENU.LANGUAGE'),
            items: this.buildLanguageItems(),
          },
        ];
      }
    }

    let roles = this.user?.roles;
    if (this.user?.roles.length > 1) {
      const filteredRoles = roles.filter(role => role !== 1 && roleMapping[role]?.code !== this.user?.role);
      const menuItemsMoreRoles = filteredRoles.map(role => ({
        label: `${roleMapping[role]?.label} ${this.translate.instant('MENU.PROFILE')}`,
        command: () => this.navigationService.changeUser(this.user, roleMapping[role].code),
      }));
      this.mobile_menu = this.mobile_menu ? [...menuItemsMoreRoles, ...this.mobile_menu] : this.mobile_menu;
    }
  }

  switchLanguage(lang: string) {
    this.translate.use(lang);
    this.updateLanguageMenuIcons(lang);
  }

  private buildLanguageItems(currentLang = this.translate.getCurrentLang()): MenuItem[] {
    return [
      {
        label: 'English',
        icon: 'pi pi-check',
        styleClass: currentLang === 'en' ? 'language-option is-active' : 'language-option',
        command: () => this.switchLanguage('en'),
      },
      {
        label: 'Čeština',
        icon: 'pi pi-check',
        styleClass: currentLang === 'cz' ? 'language-option is-active' : 'language-option',
        command: () => this.switchLanguage('cz'),
      },
    ];
  }

  updateLanguageMenuIcons(lang = this.translate.getCurrentLang()) {
    if (!this.mobile_menu) {
      return;
    }
    const languageItem = this.mobile_menu.find(item =>
      item.items?.some(child => child.label === 'English' || child.label === 'Čeština')
    );
    if (languageItem) {
      languageItem.items = this.buildLanguageItems(lang);
      this.mobile_menu = [...this.mobile_menu];
    }
  }

  signOut() {
    this.authService.signOut();
    this.router.navigate([PUBLICLOGIN]);
  }
}
